import {
    UPLOAD_GET_ALL_FILES,
    UPLOAD_DELETE_FILE,
    UPLOAD_SEARCH_FILE,
    UPLOAD_SEARCH_FILE_BY_TYPE,
    UPLOAD_UPDATE_FILE,
    UPLOAD_SAVE_UPLOADED_FILE,
    UPLOAD_TO_BUNNY_CDN
} from "../actions/upload";

import {
    API_BASE_URL,
    BUNNY_CDN_BASE_URL,
    UPLOAD_GET_ALL_FILES_URL,
    UPLOAD_DELETE_FILE_URL,
    UPLOAD_SEARCH_FILE_URL,
    UPLOAD_SEARCH_FILE_BY_TYPE_URL,
    UPLOAD_UPDATE_FILE_URL,
    UPLOAD_SAVE_UPLOADED_FILE_URL,
    UPLOAD_TO_BUNNY_CDN_URL,
    BUNNY_CDN_ACCESS_API_KEY
} from "../variables";

import axios from "axios";

const state = {};
const mutations = {};
const getters = {};
const actions = {
    [UPLOAD_TO_BUNNY_CDN]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: BUNNY_CDN_BASE_URL + UPLOAD_TO_BUNNY_CDN_URL + payload.file_name,
            method: "PUT",
            data: payload.file,
            headers: {
                AccessKey: BUNNY_CDN_ACCESS_API_KEY
            },
        });
    },
    [UPLOAD_SAVE_UPLOADED_FILE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + UPLOAD_SAVE_UPLOADED_FILE_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [UPLOAD_GET_ALL_FILES]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + UPLOAD_GET_ALL_FILES_URL,
            method: "GET",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [UPLOAD_DELETE_FILE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + UPLOAD_DELETE_FILE_URL + '/' + payload.id,
            method: "DELETE",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [UPLOAD_SEARCH_FILE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + UPLOAD_SEARCH_FILE_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [UPLOAD_SEARCH_FILE_BY_TYPE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + UPLOAD_SEARCH_FILE_BY_TYPE_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [UPLOAD_UPDATE_FILE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + UPLOAD_UPDATE_FILE_URL + '/' + payload.id,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
};


export default {
    mutations,
    actions,
    getters,
    state
};